/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class GoToIcon extends BaseIcon {
    getChildren = () => [
        <g id="Group_14379" data-name="Group 14379" transform="translate(-1269.507 -374.686)">
            <path id="Path_22648" data-name="Path 22648" d="M1528.862,442.637l5.125,5.125,5.125-5.125" transform="translate(836.025 1914.152) rotate(-90)" fill="none" stroke={this.getColor()} strokeWidth="1"/>
            <path id="Path_22649" data-name="Path 22649" d="M1533.988,453.209V438.927" transform="translate(830.58 1914.152) rotate(-90)" fill="none" stroke={this.getColor()} strokeWidth="1"/>
        </g>]
    getViewBox = () => '0 0 16 16'
}
